import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
import { useI18n } from 'vue-i18n';
import { NTooltip } from 'naive-ui';
import { TOOLTIP_DELAY_IN_MS } from '../../../constants';
import PiloteIcon from '../../generic/PiloteIcon.vue';
export default /*#__PURE__*/ _defineComponent({
    __name: 'AssistedAssignmentExclusionIcon',
    setup: function (__props) {
        var t = useI18n({ useScope: 'global' }).t;
        return function (_ctx, _cache) {
            return (_openBlock(), _createBlock(_unref(NTooltip), {
                delay: _unref(TOOLTIP_DELAY_IN_MS),
                trigger: "hover"
            }, {
                trigger: _withCtx(function () { return [
                    _createVNode(PiloteIcon, {
                        icon: "forbidden",
                        width: 18,
                        height: 18
                    })
                ]; }),
                default: _withCtx(function () { return [
                    _createTextVNode(" " + _toDisplayString(_unref(t)('assignment.exclusion.tooltip')), 1 /* TEXT */)
                ]; }),
                _: 1 /* STABLE */
            }, 8 /* PROPS */, ["delay"]));
        };
    }
});
